<div class="prestatie-header">
  <div class="thuisverzorger">
    <div class="mat-subtitle-1">{{thuisverzorger.getNaam()}}</div>
    <div>{{thuisverzorger.getPersoneelsnummer()}}</div>
  </div>
  <div class="datum">
    <div class="mat-subtitle-1">{{prestatie | zahPrestatieDatum}}</div>
    <div class="periode">
      <mat-icon>
        {{prestatie.getStartMethode() | zahPrestatieZoekmethodeIcon}}
      </mat-icon>
      <span class="uur">{{prestatie.getStartTijdstip() | zahPrestatieUur}}</span>
      <span class="separator"> - </span>
      @if (prestatie.getStopTijdstip()) {
        <span class="uur">{{prestatie.getStopTijdstip() | zahPrestatieUur}}</span>
        @if (prestatie.getStopMethode()) {
          <mat-icon>
            {{prestatie.getStopMethode() | zahPrestatieZoekmethodeIcon}}
          </mat-icon>
        }
      }
      @if (!prestatie.getStopTijdstip()) {
        <span class="uur">in uitvoering</span>
      }
    </div>
  </div>
  <div class="client">
    <div class="mat-subtitle-1">{{client.getNaam()}}</div>
    <div>{{client.getNummer()}}</div>
  </div>
</div>
